export default __webpack_public_path__ + "static/media/NL.ebe03459.png";